export default __webpack_public_path__ + "static/media/explore-tablet-5.f1d92c55.png";